<nh-form
  [individuals]="individuals"
  [formGroup]="getForm()"
  [mode]="mode"
  (validate)="onValidate($event)"
>
  <section [formGroup]="getControl('data')">
    @if (isStudentAgeHeader && !isfullTimeEligibleHeader) {
    <div>
      <h1 class="section-header">
        {{ "SCHOOL" | globalTranslate }}
      </h1>
      <hr />
    </div>
    } @if (isfullTimeEligibleHeader && isisWorkFullTimeHeader &&
    isStudentAgeHeader) {
    <div>
      <h1 class="section-header">
        {{ "SCHOOL_EMPLOYMENT" | globalTranslate }}
      </h1>
      <hr />
    </div>
    } @if (isisWorkFullTimeHeader && !isStudentAgeHeader) {
    <div>
      <h1 class="section-header">
        {{ "EMPLOYMENT" | globalTranslate }}
      </h1>
      <hr />
    </div>
    }

    <ng-container formArrayName="indvData">
      <div class="details-container mb-2">
        @for (row of schoolAndEmploymentData.controls; track row; let i =
        $index) {
        <ng-container [formGroupName]="i">
          @if (isStudentAge[i]) {
          <section [formGroup]="row['controls']['education']">
            <nh-field
              label="{{ 'IS_1' | globalTranslate }}{{ row.value.name }} {{
                'ENROLLED_SCHOOL' | globalTranslate
              }}"
              class="label-section"
              [col9]="true"
            >
              <nh-popover
                class="ps-1"
                content="{{
                  'ENROLLED_SCHOOL_STATIC_TEXT' | globalTranslate
                }} {{ 'K-12' }} {{
                  'ENROLLED_SCHOOL_STATIC_TEXT_01' | globalTranslate
                }}"
              >
              </nh-popover>
              <select
                nhTranslate
                name="currentEnrollmentStatus"
                formControlName="currentEnrollmentStatus"
                [attr.aria-label]="
                  ('IS_1' | globalTranslate) +
                  ' ' +
                  row.value.name +
                  ' ' +
                  ('ENROLLED_SCHOOL' | globalTranslate)
                "
                [items]="
                  tables[getEnrollmentStatus(getControl('data.indvData'), i)]
                "
                required
              ></select>
            </nh-field>
          </section>
          }
          <section>
            @if (fullTimeEligible[i] && isWorkFullTime[i]) {
            <nh-field
              [mandatory]="workingFullTime[i]"
              [attr.aria-required]="workingFullTime[i]"
              label="{{ 'DOES_2' | globalTranslate }}{{ row.value.name }} {{
                'FULL_TIME' | globalTranslate
              }}"
              class="label-section"
              [col9]="true"
            >
              <select
                nhTranslate
                name="isWorkingFullTime"
                [attr.aria-label]="
                  ('DOES_2' | globalTranslate) +
                  ' ' +
                  row.value.name +
                  ' ' +
                  ('FULL_TIME' | globalTranslate)
                "
                formControlName="isWorkingFullTime"
                [items]="
                  tables[getWorkFullTime(getControl('data.indvData'), i)]
                "
                required
              ></select>
            </nh-field>
            }
          </section>
        </ng-container>
        }
      </div>
    </ng-container>
  </section>
</nh-form>